<template>
    <div v-if="Object.keys(packet).length > 0">
        <TRItemsListV1 :viewdata="{packet: packet, params: request_parameters}"></TRItemsListV1>
    </div>
</template>
<script>
    import global_vars from '@/utilities/global_vars'
    import Backer from '@/components/globals/Backer'
    import TRItemsListV1 from "@/components/importables/TRItemsListV1"

    export default {
        name: "ReceivingInventory",
        props: [],
        components: {Backer, TRItemsListV1},
        data: function(){
            return {
                packet: {},
                //this is where you can play
                request_parameters: {
                    data_api_path: "/api/inventory/my_transfer_requests2/",
                    title: "RECEIVING: Inventory",
                    data_api_params: {
                        statuses: [
                            global_vars.TRANSFER_STATUSES_REVERSE_DICT["PENDING"], 
                            global_vars.TRANSFER_STATUSES_REVERSE_DICT["APPROVED"],
                            global_vars.TRANSFER_STATUSES_REVERSE_DICT["ADDED TO PULLIST"], 
                            global_vars.TRANSFER_STATUSES_REVERSE_DICT["PULLED"], 
                            global_vars.TRANSFER_STATUSES_REVERSE_DICT["PICKED"], 
                            global_vars.TRANSFER_STATUSES_REVERSE_DICT["DROPPED"], 
                            global_vars.TRANSFER_STATUSES_REVERSE_DICT["READY TO SHIP"], 
                            global_vars.TRANSFER_STATUSES_REVERSE_DICT["SHIPPED"], 
                            global_vars.TRANSFER_STATUSES_REVERSE_DICT["DELIVERED"], 
                        ],
                        userid: null,
                        userrole: null,
                        location_id: null,
                        request_types: ["transfer_for_storage"],
                        name: "ReceivingInventory"
                    }
                }
            }
        },
        methods: {},
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.packet.global_vars = global_vars;
            if (['admin', 'officeuser'].indexOf(this.packet.userDetails.userrole) < 0){
                let user_location = this.packet.userDetails.properties.location_id;
                this.packet.locations = this.packet.locations.filter(function(d){return d.value == user_location});
            }        
        }

    }
</script>


// WEBPACK FOOTER //
// src/components/Receiving/ReceivingInventory.vue